module.exports = __webpack_public_path__ + "img/service-bg3.2475b2f1.png";